import { ClientJS } from "clientjs";
import superjson from "superjson";
import packageFile from "~/package.json";

export const FP_KEY = superjson.stringify({ app: packageFile.name, id: "fp" });
export const getFingerprint = (): string => {
  const storedFp = localStorage.getItem(FP_KEY);
  if (storedFp) {
    return storedFp;
  }
  const client = new ClientJS();
  const dataPoints = [
    client.getUserAgentLowerCase(),
    client.getBrowser(),
    client.getBrowserVersion(),
    client.getOS(),
    client.getOSVersion(),
    client.getEngine(),
    client.getTimeZone(),
    client.getFonts(),
  ];
  const fingerprint = btoa(dataPoints.toString());
  const fp = fingerprint.toString();
  localStorage.setItem(FP_KEY, fp);
  return fp;
};
